import React, { useEffect, useMemo, useState } from "react";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import { useOrderContext } from "../../../contexts/Order-Context.js";
import { useMetricsContext } from "../../../contexts/Metrics-Context.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { formatPositionToPipSize, formatFixedTrimmed } from "../../../utils/format.js";
import "./SLTP.css";

import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';
import { API_ENDPOINT_SYMBOL_INFO } from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { useTranslation } from "react-i18next";

const SLTP = ({
  isPendingOrder,
  isEditPosition,
  handleSLPipsChange,
  handleTPPipsChange,
  handleDisabledButton,
  handleProfitChange,
  handleLossChange,
  editPositionId,
  entryPrice,
  secondPrice,
  onCancel
}) => {

  const { t } = useTranslation();
  const errorList = useMemo(() => ({
    buySL: t('validation.buySL'),
    sellSL: t('validation.sellSL'),
    buyTP: t('validation.buyTP'),
    sellTP: t('validation.sellTP'),
    priNeg: t('validation.validPrice'),
    priLower: t('validation.priceLowerThanBid'),
  }), [t]);

  const { metrics } = useMetricsContext();
  const { symbolData } = useSymbolContext();
  const { user, selectedAuthSymbol, platFromData } = useAuthContext();
let selectedPositionData  = null;
  // let selectedPositionDataProp = null;
  
  if(isEditPosition){
   selectedPositionData = platFromData[3]?.openedPositions.find((item) => item.id == editPositionId) 
    // selectedPositionDataProp = selectedPosition;
  }else{
    selectedPositionData =platFromData[4]?.openedOrders.find((item) => item.order_id == editPositionId)
    // selectedPositionDataProp = selectedPositionOrder;
  }
  const editTick = symbolData?.[selectedPositionData?.symbol];
  // Pending edits use entry-side FX. Open-position edits use mark-side FX,
  // matching the account PnL shown for the existing position.
  const useAskFx = isPendingOrder
    ? selectedPositionData?.direction === 'Buy'
    : selectedPositionData?.direction === 'Sell';
  const liveEditFx = useAskFx
    ? Number(editTick?.ea)
    : Number(editTick?.eb);
  const exchangeRateUsdt = liveEditFx || Number(selectedPositionData?.exchangeRateUsdt) || 1;
  const positionDetails = selectedPositionData
    const selectedPositionDataExchangeRate = selectedPositionData?.exchangeRate * exchangeRateUsdt
 
  const direction = selectedPositionData?.direction;
  const quantity = parseFloat(selectedPositionData?.quantity);

  useEffect(() => {
      if (!selectedPositionData) {
        onCancel();
        return;
      }
    }, [selectedPositionData]);


  const [isSLSelected, setIsSLSelected] = useState(
    positionDetails && positionDetails.SL && positionDetails.SL > 0
      ? true
      : false
  );
  const [isTPSelected, setIsTPSelected] = useState(
    positionDetails && positionDetails.TP && positionDetails.TP > 0
      ? true
      : false
  );

  const [pipSize, setPipSize] = useState(null);
  const [slPrice, setSlPrice] = useState(
    positionDetails && positionDetails.SL && positionDetails.SL > 0
      ? parseFloat(positionDetails.SL)
      : 0.0
  );
  const [slBalance, setSlBalance] = useState(0.0);
  const [slProfit, setSlProfit] = useState(0.0);
  const [slPips, setSlPips] = useState(0.0);
  const [tpPrice, setTpPrice] = useState(
    positionDetails && positionDetails.TP && positionDetails.TP > 0
      ? parseFloat(positionDetails.TP)
      : 0.0
  );
  const [tpBalance, setTpBalance] = useState(0.0);
  const [tpProfit, setTpProfit] = useState(0.0);
  const [tpPips, setTpPips] = useState(0.0);
  const [slSelectedState, setSlSelectedState] = useState("");

  const [isSLError, setIsSLError] = useState(false);
  const [isTPError, setIsTPError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageTP, setErrorMessageTP] = useState("")

  // Format for display only - calculations use full precision.
  // Keep "0" / "0." while typing so users can enter 0 and decimals.
  const displayIfNonZero = (v, decimals = 10) => {
    if (v === null || v === undefined || v === "") return "";
    if (typeof v === "string" && (v === "." || v.endsWith(".") || /^-?\d*\.0+$/.test(v))) {
      return v;
    }
    const n = typeof v === "string" ? Number(v) : v;
    // Empty until the user types — show placeholder "0", not a filled zero.
    if (!Number.isFinite(n) || n === 0) return "";
    return formatFixedTrimmed(n, decimals);
  };
  const parseSltpInput = (val) => {
    if (val === "" || val === "." || /^-?\d*\.$/.test(val) || /^-?\d*\.0+$/.test(val)) {
      return val;
    }
    const numVal = parseFloat(val);
    return isNaN(numVal) ? 0 : numVal;
  };
  const isAllowedSltpInput = (val) =>
    val.length <= 32 && (val === "" || /^-?\d*\.?\d{0,10}$/.test(val));
  useEffect(() => {
    if (!(pipSize > 0)) {
      handleDisabledButton(true);
    } else if (isSLSelected && (slPrice < 0 || slProfit < 0)) {
      handleDisabledButton(true);
    } else if (isTPSelected && (tpPrice < 0 || tpProfit < 0)) {
      handleDisabledButton(true);
    } else {
      handleDisabledButton(isSLError || isTPError);
    }
  }, [pipSize, isSLError, isTPError, isSLSelected, isTPSelected, slPrice, slProfit, tpPrice, tpProfit])
  
  // Check for negative SL price or profit
  useEffect(() => {
    if (isSLSelected && (slPrice < 0 || slProfit < 0)) {
      setIsSLError(true);
      if (slPrice < 0) {
        setErrorMessage(t('validation.pricePositive'));
      } else if (slProfit < 0) {
        setErrorMessage(t('validation.profitPositive'));
      }
    } else if (isSLSelected && slPrice > 0 && slProfit > 0) {
      setIsSLError(false);
      setErrorMessage("");
    }
  }, [slPrice, slProfit, isSLSelected]);
  
  const [tpSelectedState, setTpSelectedState] = useState("");

  const updateSymbolInfo = async (symbol) => {
    try {
      if (user && user.userId != undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_SYMBOL_INFO(user.userId, symbol),
        );
        const responseData = response.data[0];
        
        setPipSize(formatPositionToPipSize(responseData.pip_position));
      }
    } catch (error) {
      // Handle API request error
      console.error(`API request error: ${API_ENDPOINT_SYMBOL_INFO}`, error);
    }
  };

  useEffect(() => {
    if (!isSLSelected || slPrice === 0) {
      setIsSLError(false);
      setErrorMessage("");
      return;
    }

    const pnl = parseFloat(selectedPositionData?.pnl ?? 0);

    if (slProfit < pnl * -1) {
      setIsSLError(true);
      setErrorMessage(`Stop Loss cannot be greater than ${pnl}`);
      return;
    } else {
      setIsSLError(false);
      setErrorMessage("");
    }
  }, [platFromData, editPositionId, slProfit, isSLSelected, slPrice]);

  useEffect(() => {
    if (!isTPSelected || tpPrice === 0) {
      setIsTPError(false);
      setErrorMessageTP("");
      return;
    }

    const pnl = parseFloat(selectedPositionData?.pnl ?? 0);

    if (tpProfit <= pnl) {
      setIsTPError(true);
      setErrorMessageTP(`Take Profit must be greater than current PnL (${pnl.toFixed(2)})`);
    } else {
      setIsTPError(false);
      setErrorMessageTP("");
    }
  }, [platFromData, editPositionId, tpProfit, isTPSelected, tpPrice]);


  useEffect(() => {
    if (!(pipSize > 0)) return;
    if (isSLSelected && slSelectedState === "pips") {
      slPips_fn(slPips);
    } else if (isSLSelected && slSelectedState === "price") {
      slPrice_fn(slPrice);
    } else if (isSLSelected && slSelectedState === "balance") {
      slBalance_fn(slBalance);
    } else if (isSLSelected && slSelectedState === "profit") {
      slProfit_fn(slProfit);
    }

    if (isTPSelected && tpSelectedState === "pips") {
      tpPips_fn(tpPips);
    } else if (isTPSelected && tpSelectedState === "price") {
      tpPrice_fn(tpPrice);
    } else if (isTPSelected && tpSelectedState === "balance") {
      tpBalance_fn(tpBalance);
    } else if (isTPSelected && tpSelectedState === "profit") {
      tpProfit_fn(tpProfit);
    }
  }, [direction, quantity, entryPrice, pipSize, selectedPositionDataExchangeRate]);
  useEffect(() => {
    updateSymbolInfo(selectedPositionData?.symbol);
  }, [selectedPositionData?.symbol]);
  useEffect(() => {
    // Only derive pips/PNL when a real price exists — never from price 0
    if (!(pipSize > 0)) return;
    if (isSLSelected && Number(slPrice) > 0 && !slSelectedState) {
      reCalculate_slPrice_fn();
    }
    if (isTPSelected && Number(tpPrice) > 0 && !tpSelectedState) {
      reCalculate_tpPrice_fn();
    }
  }, [pipSize, entryPrice, selectedPositionDataExchangeRate]);
  
  // Initial calculation when component mounts with existing position data
  // useEffect(() => {
  //   if (isEditPosition && pipSize > 0 && selectedPositionData && metrics.balance) {
  //     if (isSLSelected && slPrice > 0) {
  //       reCalculate_slPrice_fn();
  //     }
  //     if (isTPSelected && tpPrice > 0) {
  //       reCalculate_tpPrice_fn();
  //     }
  //   }
  // }, [isEditPosition, selectedPositionData, metrics.balance, pipSize, isSLSelected, isTPSelected]);
  // useEffect(() => {
  //   if (!isEditPosition) {
  //     setSlPips(0.0);
  //     handleSLPipsChange(0.0);
  //     handleTPPipsChange(0.0);
  //     setSlProfit(0.0);
  //     setSlBalance(0.0);
  //     setSlPrice(0.0);
  //     setTpPrice(0.0);
  //     setTpPips(0.0);
  //     setTpProfit(0.0);
  //     setTpBalance(0.0);
  //     handleLossChange(0.0);
  //     handleProfitChange(0.0);
  //     setSlSelectedState("");
  //     setTpSelectedState("");
  //   }
  // }, [selectedAuthSymbol]);
  // useEffect(() => {
  //   if (!isEditPosition) {
  //     setSlPips(0.0);
  //     handleSLPipsChange(0.0);
  //     handleTPPipsChange(0.0);
  //     setSlProfit(0.0);
  //     setSlBalance(0.0);
  //     setTpPips(0.0);
  //     setSlPrice(0.0);
  //     setTpPrice(0.0);
  //     setTpProfit(0.0);
  //     setTpBalance(0.0);
  //     handleLossChange(0.0);
  //     handleProfitChange(0.0);
  //     setSlSelectedState("");
  //     setTpSelectedState("");
  //   }
  // }, [
  //   quantity === null ||
  //     quantity <= 0 ||
  //     quantity === undefined ||
  //     isNaN(quantity),
  // ]);

  const sltpToggle = (e) => {
    if (e.target.id === "stop_loss") {
      setIsSLSelected(e.target.checked);
      setIsSLError(false);
      setErrorMessage("");
      setSlPips(0.0);
      setSlPrice(0.0);
      handleSLPipsChange(0.0);
      setSlProfit(0.0);
      setSlBalance(0.0);
      handleLossChange(0.0);

      setSlSelectedState("");
    }

    if (e.target.id === "take_profit") {
      setIsTPSelected(e.target.checked);
      setIsTPError(false);
      setErrorMessageTP("");
      setTpPips(0.0);
      handleTPPipsChange(0.0);
      setTpPrice(0.0);
      setTpProfit(0.0);
      setTpBalance(0.0);
      handleProfitChange(0.0);
      setTpSelectedState("");
    }
  };
  const slPips_fn = (e) => {
    setSlSelectedState("pips");
    setSlPips(e);
    handleSLPipsChange(e);

    if (direction === "Buy") {
      const pip_movement = pipSize * e;
      const price = entryPrice - pip_movement;
      if (price > secondPrice || price < 0) {
        if (price < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (price > secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        }
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }
      const loss_profit_in_quote = quantity * (entryPrice - price);
      const loss_profit_in_account_currecny = loss_profit_in_quote * selectedPositionDataExchangeRate;

      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

  
    setSlPrice(price);
    setSlBalance(balance);
    setSlProfit(loss_profit_in_account_currecny);

      handleLossChange(price);
    }

    ///////STOP LOSS DIRECTION SELL
    if (direction === "Sell") {
      const pip_movement = pipSize * e;

      const price = parseFloat(entryPrice) + pip_movement;
      if (price < secondPrice || price < 0) {
        if (price < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (price < secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.sellSL || "price should be greater than ask price");
        }
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }
      const loss_profit_in_quote = quantity * (price - parseFloat(entryPrice));
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPrice(price);

      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);

      handleLossChange(price);
    }
  };
  const reCalculate_slPrice_fn = () => {
    setSlSelectedState("price");

    if (direction == "Buy") {
      
      const pip_movement = entryPrice - slPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - slPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;
      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(slPrice));
    }

    ////////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = slPrice - entryPrice;

      const pips = pip_movement / pipSize;

      const loss_profit_in_quote = quantity * (slPrice - entryPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(slPrice));
    }
  };
  const slPrice_fn = (e) => {
    setSlSelectedState("price");
    setSlPrice(e);

    if (direction == "Buy") {
      const pip_movement = entryPrice - e;
      
      if(e < 0 || e >= secondPrice){
        if (e < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (e >= secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }
      else{
        if (pip_movement < 0) {
          setIsSLError(true);
          setErrorMessage(errorList.priNeg);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }

      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - e);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(e));
    }

    ////////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = e - entryPrice;

      if(e < 0 || e < secondPrice){
        if (e < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (e < secondPrice) {
          setIsSLError(true);
          setErrorMessage("price should be greater than ask price");
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }
      else{
        if (pip_movement < 0) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }

      

      const pips = pip_movement / pipSize;

      const loss_profit_in_quote = quantity * (e - entryPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(e));
    }
  };
  const slBalance_fn = (e) => {
    setSlSelectedState("balance");
    setSlBalance(e);

    if (direction == "Buy") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;
      const price =
        entryPrice -
        (loss_profit_in_account_currecny / quantity) / selectedPositionDataExchangeRate;
        if(price < 0 || price > secondPrice){
          if (price < 0) {
            setIsSLError(true);
            setErrorMessage(t('validation.pricePositive'));
          } else if (price > secondPrice) {
            setIsSLError(true);
            setErrorMessage(errorList.buySL);
          }
      }
      else{
        setIsSLError(false);
        setErrorMessage("");
      }

      const pip_movement = entryPrice - price;
      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlPrice(price);

      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }

    // ////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;
      const price =
      parseFloat(entryPrice) +
        (loss_profit_in_account_currecny / quantity) / selectedPositionDataExchangeRate;
      const pip_movement = price - entryPrice;

      if (pip_movement < 0 || price < secondPrice || price < 0) {
        if (price < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (pip_movement < 0 || price < secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        }
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }

      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlPrice(price);

      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }
  };
 const slProfit_fn = (e) => {
    setSlSelectedState("profit");
    setSlProfit(e);

    if (direction == "Buy") {
      const balance = (e / metrics.balance) * 100;

      const price = entryPrice - (e / quantity) / selectedPositionDataExchangeRate;

      const pip_movement = entryPrice - price;

      if (price < 0 || price > secondPrice) {
        if (price < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
          handleDisabledButton(true);
        } else if (price > secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
          handleDisabledButton(true);
        }
    } else {
      setIsSLError(false);
      setErrorMessage("");
      handleDisabledButton(false);
    }
      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);

      setSlPrice(price);

      handleLossChange(price);
    }

    if (direction == "Sell") {
      const balance = (e / metrics.balance) * 100;

      const price = parseFloat(entryPrice) + (e / quantity) / selectedPositionDataExchangeRate;

      const pip_movement = price - entryPrice;

      if (price < 0 || pip_movement < 0) {
        if (price < 0) {
          setIsSLError(true);
          setErrorMessage(t('validation.pricePositive'));
        } else if (pip_movement < 0) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        }
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }

      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlPrice(price);

      handleLossChange(price);
    }
  };
  const tpPips_fn = (e) => {
    setTpSelectedState("pips");
    setTpPips(e);
    handleTPPipsChange(e);
    if (direction == "Buy") {
      const pip_movement = e * pipSize;
      const price = parseFloat(entryPrice) + pip_movement;
      if (price < 0 || price < secondPrice) {
        setIsTPError(true);
        if (price < 0) {
          setErrorMessageTP(t('validation.pricePositive'));
        } else if (price < secondPrice) {
          setErrorMessageTP(errorList.buyTP);
        }
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const loss_profit_in_quote = quantity * (price - parseFloat(entryPrice));

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;

      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;
      setTpPrice(price);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }

    ///////TAKE PROFIT DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = e * pipSize;
      const price = entryPrice - pip_movement;
      if (price < 0 || price > secondPrice) {
        setIsTPError(true);
        setErrorMessageTP(errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const loss_profit_in_quote = quantity * (entryPrice - price);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPrice(price);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }
  };
  const tpPrice_fn = (e) => {
    setTpSelectedState("price");
    setTpPrice(e);

    if (direction == "Buy") {
      const pip_movement = entryPrice - e;

      if (e < 0 || e < secondPrice) {
        setIsTPError(true);
        if (e < 0) {
          setErrorMessageTP(t('validation.pricePositive'));
        } else if (e < secondPrice) {
          setErrorMessageTP(errorList.buyTP);
        }
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pips = Math.abs(pip_movement) / pipSize;
      const loss_profit_in_quote = quantity * (e - entryPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(parseFloat(e));
    }

    ////////////Take PROFIT DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = entryPrice - e;
      if (e < 0 || e > entryPrice) {
        setIsTPError(true);
        if (e < 0) {
          setErrorMessageTP(t('validation.pricePositive'));
        } else if (e > entryPrice) {
          setErrorMessageTP(errorList.priLower);
        }
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const pips = Math.abs(pip_movement) / pipSize;
      const loss_profit_in_quote = Math.abs(quantity * (e - entryPrice));
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(parseFloat(e));
    }
  };

  // entryPrice from Edit modal is often a trimmed string; position.entry_price is a number.
  // Old code used != and wiped SL/TP to 0 on any format mismatch, then recalc from price 0
  // produced bogus pips/PNL (e.g. 64 pips / $6400). Keep prices; only refresh derived fields.
  useEffect(() => {
    if (!selectedPositionData) return;
    const formN = Number(entryPrice);
    if (!Number.isFinite(formN) || formN <= 0) return;

    if (isSLSelected && Number(slPrice) > 0) {
      slPrice_fn(slPrice);
    }
    if (isTPSelected && Number(tpPrice) > 0) {
      tpPrice_fn(tpPrice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryPrice]);

  const reCalculate_tpPrice_fn = () => {
    setTpSelectedState("price");

    if (direction == "Buy") {
      const pip_movement = entryPrice - tpPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (tpPrice - entryPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(Math.abs(pips));
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(parseFloat(tpPrice));
    }

    ////////////Take PROFIT DIRECTION SELL
    // Sell TP is below entry → profit = qty * (entry - tp). Using (tp - entry) made
    // reopen/edit show −$10 for a real +$10 TP (common on forex after pipSize recalc).
    if (direction == "Sell") {
      const pip_movement = entryPrice - tpPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - tpPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedPositionDataExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(Math.abs(pips));
      handleTPPipsChange(Math.abs(pips));
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(parseFloat(tpPrice));
    }
  };
  const tpBalance_fn = (e) => {
    setTpSelectedState("balance");
    setTpBalance(e);

    if (direction == "Buy") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;

      const price =
      parseFloat(entryPrice)  +
        (loss_profit_in_account_currecny / quantity) / selectedPositionDataExchangeRate;

      const pip_movement = price - entryPrice;

      if (price < secondPrice) {
        setIsTPError(true);
        setErrorMessageTP(errorList.buyTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpPrice(price);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }

    ////////Take Profit DIRECTION SELL
    if (direction == "Sell") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;

      const price = Math.abs(entryPrice -
          (loss_profit_in_account_currecny / quantity) / selectedPositionDataExchangeRate);

      if (price < 0 || price > secondPrice) {
        setIsTPError(true);
        setErrorMessageTP(errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pip_movement = Math.abs(price - entryPrice);

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpPrice(price);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }
  };
  const tpProfit_fn = (e) => {
    setTpSelectedState("profit");
    setTpProfit(e);

  
    const pnl = parseFloat(selectedPositionData?.pnl ?? 0);

    if (e <= pnl) {
      setIsTPError(true);
      setErrorMessageTP(`Take Profit must be greater than current PnL (${pnl.toFixed(2)})`);
      return;
    } else {
      setIsTPError(false);
      setErrorMessageTP("");
    }

    // continue with your existing calculation...
    if (direction == "Buy") {
      const balance = (e / metrics.balance) * 100;
      const price = parseFloat(entryPrice) + (e / quantity) / selectedPositionDataExchangeRate;
      const pip_movement = Math.abs(entryPrice - price);

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpPrice(price);

      handleProfitChange(price);
    }

    if (direction == "Sell") {
      const balance = (e / metrics.balance) * 100;
      const price = entryPrice - (e / quantity) / selectedPositionDataExchangeRate;
      const pip_movement = entryPrice - price;
      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpPrice(price);

      handleProfitChange(price);
    }
  };

  const isDisabledSLInput = () => {
    if (quantity > 0 && isSLSelected && parseFloat(entryPrice) > 0) {
      return false;
    } else {
      return true;
    }
  };
  const isDisabledTPInput = () => {
    if (quantity > 0 && isTPSelected && parseFloat(entryPrice) > 0) {
      return false;
    } else {
      return true;
    }
  };
  const handleScroll = (e) => {
    // e.preventDefault();
    e.target.blur();
  }
  return (
    <>
      <div
        className="sltp-container"
        style={{ display: "flex", width: "100%" }}
      >
        <div className="left">
          <div className="stop-loss sltp-checkbox">
            <input
              hidden
              type="checkbox"
              id="stop_loss"
              checked={isSLSelected}
              onChange={sltpToggle}
            />
            <label
              htmlFor="stop_loss"
              className="my-chk-xbx"
              role={isSLSelected ? "checked" : "unchecked"}
            >
              <div
                className="chkx-xbx"
                onClick={() => {
                  // mkRipple(j);
                }}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  isolation: 'isolate',
                }}
              >
                <Ripple />
              </div>
              <span className="col-white">{t('ea.stopLoss')}</span>
            </label>
          </div>
          {(isSLSelected || isTPSelected) && (
            <div className="input-ov">
              <input
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                className={`sl_pips ${
                  isDisabledSLInput() ? "disabled-fields" : ""
                }`}
                value={isSLSelected ? displayIfNonZero(slPips) : ""}
                placeholder="0"
                disabled={isDisabledSLInput()}
                maxLength={32}
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    slPips_fn(parseSltpInput(val));
                  }
                }}
                step={pipSize}
              />

              <input
                title={slPrice < 0 ? t('validation.pricePositive') : errorMessage}
                value={isSLSelected ? displayIfNonZero(slPrice) : ""}
                placeholder="0"
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    slPrice_fn(parseSltpInput(val));
                  }
                }}
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                disabled={isDisabledSLInput()}
                maxLength={32}
                className={`sl_price ${
                  isDisabledSLInput() ? "disabled-fields" : ""
                }`}
                style={
                  (isSLError || slPrice < 0) && !isPendingOrder
                    ? {
                        background: "#8e3f3f",
                        borderWidth: "2px",
                        borderStyle: "solid",
                      }
                    : {}
                }
                step={0.001}
              />

              <input
                value={isSLSelected ? displayIfNonZero(slBalance) : ""}
                placeholder="0"
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    slBalance_fn(parseSltpInput(val));
                  }
                }}
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                disabled={isDisabledSLInput()}
                maxLength={32}
                className={`sl_balance ${
                  isDisabledSLInput() ? "disabled-fields" : ""
                }`}
                step={0.01}
              />
              <input
                title={slProfit < 0 ? t('validation.profitPositive') : errorMessage}
                value={isSLSelected ? displayIfNonZero(slProfit) : ""}
                placeholder="0"
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    slProfit_fn(parseSltpInput(val));
                  }
                }}
                type="text"
                inputMode="decimal"
                min="0"
                onWheel={handleScroll}
                disabled={isDisabledSLInput()}
                maxLength={32}
                className={`sl_profit ${isDisabledSLInput() ? "disabled-fields" : ""}`}
                style={
                  (isSLError || slProfit < 0) && !isPendingOrder ? { background: "#8e3f3f", borderWidth: "2px", borderStyle: "solid" } : {}
                }
              />
            </div>
          )}
        </div>
        {(isSLSelected || isTPSelected) && (
          <div className="center input-ov labels-pips">
            <p style={{marginBottom: '0 !important'}}></p>
            <p className="col-white">{t('orderPanel.pips')}</p>
            <p className="col-white">{t('orderPanel.price')}</p>
            <p>
              <pre className="col-white">{t('orderPanel.percentBalance')} </pre>
            </p>
            <p>
              <pre className="col-white">
                {t('orderPanel.profitApprox', { symbol: {'EUR': '€', 'USD': '$'}[user?.userCurrencyName] || '€' })}
              </pre>
            </p>
          </div>
        )}
        <div className="right">
          <div className="take-profit sltp-checkbox">
            <input
              hidden
              type="checkbox"
              name="take_profit"
              id="take_profit"
              checked={isTPSelected}
              onChange={sltpToggle}
            />
            <label
              htmlFor="take_profit"
              className="my-chk-xbx"
              role={isTPSelected ? "checked" : "unchecked"}
            >
              <div
                className="chkx-xbx"
                onClick={() => {
                  // mkRipple(j);
                }}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  isolation: 'isolate',
                }}
              >
                <Ripple />
              </div>
              <span className="col-white">{t('ea.takeProfit')}</span>
            </label>
          </div>
          {(isSLSelected || isTPSelected) && (
            <div className="input-ov">
              <input
                value={isTPSelected ? displayIfNonZero(tpPips) : ""}
                placeholder="0"
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                disabled={isDisabledTPInput()}
                maxLength={32}
                className={`tp_pips ${
                  isDisabledTPInput() ? "disabled-fields" : ""
                }`}
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    tpPips_fn(parseSltpInput(val));
                  }
                }}
                step={pipSize}
              />
                <input
                  value={isTPSelected ? displayIfNonZero(tpPrice) : ""}
                  placeholder="0"
                  title={tpPrice < 0 ? t('validation.pricePositive') : errorMessageTP}
                  type="text"
                inputMode="decimal"
                  onWheel={handleScroll}
                  step={0.001}
                  maxLength={32}
                  className={`tp_price ${
                    isDisabledTPInput() ? "disabled-fields" : ""
                  }`}
                  style={
                    (isTPError || tpPrice < 0) && !isPendingOrder
                      ? {
                          background: "#8e3f3f",
                          borderWidth: "2px",
                          borderStyle: "solid",
                        }
                      : {}
                  }
                  disabled={isDisabledTPInput()}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (isAllowedSltpInput(val)) {
                      tpPrice_fn(parseSltpInput(val));
                    }
                  }}
                />
              
              
              <input
                value={isTPSelected ? displayIfNonZero(tpBalance) : ""}
                placeholder="0"
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                maxLength={32}
                className={`tp_balance ${
                  isDisabledTPInput() ? "disabled-fields" : ""
                }`}
                disabled={isDisabledTPInput()}
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    tpBalance_fn(parseSltpInput(val));
                  }
                }}
                step={0.01}
              />
              <input
                value={isTPSelected ? displayIfNonZero(tpProfit) : ""}
                placeholder="0"
                type="text"
                inputMode="decimal"
                onWheel={handleScroll}
                maxLength={32}
                className={`tp_profit ${isDisabledTPInput() ? "disabled-fields" : ""}`}
                style={
                  isTPError && !isPendingOrder
                    ? { background: "#8e3f3f", borderWidth: "2px", borderStyle: "solid" }
                    : {}
                }
                disabled={isDisabledTPInput()}
                onChange={(e) => {
                  const val = e.target.value;
                  if (isAllowedSltpInput(val)) {
                    tpProfit_fn(parseSltpInput(val));
                  }
                }}
                onKeyDown={e => {
                  if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const inc = parseFloat(+tpPips + +pipSize);
                    tpPips_fn(inc);
                  } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const dec = parseFloat(+tpPips - +pipSize);
                    tpPips_fn(dec);
                  };
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SLTP;
